// AiSol Med modules and texts of the connection pages (ТЗ §4, приложение А).

import type { ModuleId } from "./types.ts";

export interface ModuleInfo {
  id: ModuleId | "coding-services";
  title: string;
  icon: "mic" | "cam" | "tag" | "shield" | "chart" | "phone";
  what: string;
  steps: string[];
  gets: string;
}

export const MODULES: ModuleInfo[] = [
  {
    id: "voice",
    title: "Голосовая запись приёма",
    icon: "mic",
    what: "Врач ведёт приём как обычно и включает запись на телефоне. Платформа расшифровывает разговор, раскладывает его по разделам осмотра и предлагает коды МКБ-10 с обоснованием.",
    steps: ["Врач включает запись приёма", "Платформа расшифровывает разговор", "Раскладывает его по разделам осмотра и предлагает коды", "Врач проверяет и копирует протокол в МИС"],
    gets: "Врач не печатает осмотр, протоколы полные и единообразные.",
  },
  {
    id: "docs",
    title: "Распознавание документов",
    icon: "cam",
    what: "Выписки, результаты анализов, направления и документы сторонних клиник с фото, сканов и PDF переводятся в структурированные данные и подтягиваются в карту.",
    steps: ["Загрузите фото, скан или PDF", "Платформа распознаёт текст и таблицы", "Раскладывает данные по полям — показатели анализов, диагнозы, даты", "Врач проверяет и сохраняет"],
    gets: "Нет ручного перепечатывания, данные анализов доступны для проверок и аналитики.",
  },
  {
    id: "coding",
    title: "Кодирование МКБ-10 и услуг",
    icon: "tag",
    what: "Коды МКБ-10 предлагаются по записи приёма и сразу проверяются на ошибки.",
    steps: ["Врач ведёт приём", "Платформа предлагает коды с обоснованием", "Проверяет коды на ошибки", "Врач подтверждает"],
    gets: "Ошибки в кодах исправляются в момент приёма, а не после снятия.",
  },
  {
    id: "compliance",
    title: "Комплаенс-проверка перед ФСМС",
    icon: "shield",
    what: "Каждый случай до отправки реестра проверяется по правилам фонда и действующим приказам: полнота документации, соответствие кодов, сроки, обоснованность услуг.",
    steps: ["Платформа получает случаи за период", "Проверяет каждый по правилам", "Для каждого дефекта показывает, что не так и как исправить", "Ответственный исправляет до отправки"],
    gets: "Снятия предотвращаются заранее, а не оспариваются задним числом.",
  },
  {
    id: "audit",
    title: "Аудит-светофор и аналитика",
    icon: "chart",
    what: "Панель руководителя: риски снятий по отделениям и врачам, скоркарты врачей, динамика дефектов, бюджет и исполнение в разрезе отделений.",
    steps: ["Платформа собирает результаты проверок и данные случаев", "Считает риски и показатели", "Раскрашивает отделения и врачей по светофору", "Руководитель проваливается до конкретного случая"],
    gets: "Руководство видит, где теряются деньги, до того как их потеряли.",
  },
  {
    id: "callcenter",
    title: "AI-колл-центр и оповещение пациентов",
    icon: "phone",
    what: "Голосовой ассистент принимает входящие звонки (запись, перенос, справки) и ведёт исходящие кампании: напоминания о приёме, приглашения на скрининги и вакцинацию, диспансерный вызов, сообщение о готовности результатов.",
    steps: ["Пациент звонит или получает звонок", "Ассистент ведёт разговор", "Записывает, переносит или передаёт оператору", "Каждый звонок — со стенограммой и итогом в журнале"],
    gets: "Ни один звонок не теряется, списки прикреплённого населения отрабатываются полностью.",
  },
];

export const CODING_SERVICES: ModuleInfo = {
  id: "coding-services",
  title: "Кодирование услуг",
  icon: "tag",
  what: "По тексту записи платформа подсказывает повод обращения и услуги по тарификатору и объясняет, почему предложена именно эта услуга.",
  steps: ["Врач ведёт приём", "Платформа сопоставляет назначенное с тарификатором", "Предлагает услуги и повод обращения с обоснованием", "Врач подтверждает"],
  gets: "Ошибка в услугах исправляется в момент ввода, а не после снятия.",
};

export const MODULE_IDS = MODULES.map((m) => m.id as ModuleId);
export const DEFAULT_CLINIC_MODULES: ModuleId[] = ["voice", "coding"];

export const moduleTitle = (id: string) => (id === "coding-services" ? CODING_SERVICES.title : MODULES.find((m) => m.id === id)?.title ?? id);
